import {createSlice} from '@reduxjs/toolkit';

export const adminSlice = createSlice({
  name: 'admin',
  initialState: {isAdmin: false, panel: false},
  reducers: {
    setAdmin: (state) => {
      state.isAdmin = true;
    },
    setPanel: (state, action) => {
      state.panel = action.payload;
    },
  },
});

export const {setAdmin, setPanel} = adminSlice.actions;

export const isAdmin = (state) => state.admin.isAdmin;
export const adminPanel = (state) => state.admin.panel;

export default adminSlice.reducer;
